import { alertWithMessage } from "components/modal/message_modal";
import { alertWithSuccessMessage } from "components/modal/success_modal";
import { MaxButton } from "components/view/button";
import TimerCheckin from "components/view/timer_checkin";
import checkin_bet from "lib/worker/api/checkin_bet";
import check_time, { CheckTimeResponse } from "lib/worker/api/check_time";
import Link from "next/link";
import React, { useEffect } from "react";
import { useState } from "react";
import LayoutMaster from "../../components/layout/layout_master";
import Img from "react-cloudimage-responsive";
import getinfo from "lib/worker/api/getinfo";
import { connect } from "react-redux";
import { AppReducerStateProps } from "lib/store";
import check_in_reward_all_award_status from "lib/worker/api/check_in_reward_all_award_status";
import UboxRewardShow from "components/view/ubox_reward_show";
import { TimeState } from "lib/time";
import CheckinProgress from "components/view/checkin_progress";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface CheckInUdiamondProps {
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function CheckInUdiamond(props: CheckInUdiamondProps) {
  const [checkTime, setCheckTime] = useState<CheckTimeResponse>();
  const [awards, setAwards] = useState<CheckTimeResponse[]>();
  const [isCheckin, setIsCheckin] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadTime, setLoadTime] = useState<boolean>(false);

  useEffect(() => {
    if (props.isLogin) {
      time();
    }
  }, []);

  const time = () => {
    setLoadTime(false);
    check_time().then((json) => {
      setCheckTime(json);
      setIsCheckin(true);
      setLoadTime(true);
    });

    check_in_reward_all_award_status().then((json) => {
      setAwards(json);
    });
  };

  const isCheckIn = (diff: TimeState) => {
    setIsCheckin((diff.diff ?? 0) <= 0);
  };

  const checkin = () => {
    if (!props.isLogin) {
      alertWithMessage("กรุณาเข้าสู่ระบบ ถึงจะสามารถเล่นเกมได้");
      return;
    }

    setLoading(true);
    checkin_bet()
      .then((json) => {
        alertWithSuccessMessage(json.message ?? "");
      })
      .finally(() => {
        time();
        setLoading(false);
        getinfo();
      })
      .catch((error) => {
        alertWithMessage(error.response.data.message);
      });
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "กิจกรรมเช็คชื่อ",
        description: "กิจกรรมเช็คชื่อ แจก uDiamond เพื่อนำไปแลกเครดิต",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <h1 className="text-center">
          <span>กิจกรรมเช็คอินรับ uDiamond ฟรี!!</span>
        </h1>
        <p className="text-center">
          เช็คอินครั้งถัดไปรับรางวัล {checkTime?.amount?.format(0, 0)} uDiamond
        </p>
        <div className="row center-content margin-top-20">
          <div className="view-background col-6 col-sm-6 col-md-4 col-lg-3 checkin">
            <Img className="full-width-image" src="checkin-ani.png"></Img>
          </div>
        </div>
        <div className="col-8 col-md-4 col-lg-3 center-row-content">
          <MaxButton
            title="เช็คอิน รับ uDiamond"
            className="bg-invite button-glowing margin-top-30 margin-bottom-20"
            loading={loading}
            onClick={checkin}
            lock={!isCheckin}
          ></MaxButton>
        </div>
        <div className="text-center">
          {loadTime && (
            <TimerCheckin
              timeAt={checkTime?.TimeAt}
              onTimeMins={(diff: TimeState) => {
                isCheckIn(diff);
              }}
            ></TimerCheckin>
          )}
        </div>
        {loadTime && (
          <div className="row text-center">
            <div className="col-12 margin-top-20">
              <CheckinProgress></CheckinProgress>
            </div>
          </div>
        )}
        <div className="margin-top-20">
          <h4 className="text-title">วิธีการเข้าร่วมกิจกรรม</h4>
          <li>
            กดปุ่ม <span>เช็คอิน รับ uDiamond</span> เพื่อรับ{" "}
            <span>uDiamond ฟรี</span>
          </li>
          <li>รับ uDiamond สูงสุด 48 ครั้ง</li>
          <li>
            <span>uDiamond</span> สามารถนำไปแลกเป็นเครดิตได้{" "}
            <Link href="/exchange">
              <a>
                <span>คลิกแลกเครดิตฟรี</span>
              </a>
            </Link>
          </li>
        </div>
      </div>
      <div className="container">
        {(awards ?? []).map((award, i) => {
          return (
            <>
              <UboxRewardShow
                List={`${i + 1} - ของรางวัล`}
                Name={`รางวัล ${award.amount?.format(0, 0)} uDiamond`}
                Pc={award.is_reward ? "เช็คอินแล้ว" : "กำลังรอการเช็คอิน"}
                Color={award.is_reward ? "red" : ""}
              ></UboxRewardShow>
            </>
          );
        })}
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    getinfo: state.member.getinfo,
    isLogin: state.member.isLogin,
  };
};

export default connect(mapStateToProps)(CheckInUdiamond);
